interface CreatorConvergenceAlertProps {
  competitorName: string
  creatorCount: number
  timeWindowDays?: number
  narrative?: string | null
  className?: string
}

export default function CreatorConvergenceAlert({
  competitorName,
  creatorCount,
  timeWindowDays = 7,
  narrative = null,
  className = '',
}: CreatorConvergenceAlertProps) {
  const count = Math.max(0, Math.round(creatorCount || 0))
  const text = narrative?.trim() || `${count} creators in ${timeWindowDays} days — convergence detected. Check for paid signals.`

  return (
    <article className={`rounded-lg border border-[var(--gray-200)] bg-white px-3 py-2 ${className}`}>
      <div className="flex items-center gap-2">
        <span className="text-[var(--danger-600)]" aria-hidden>
          ●
        </span>
        <span className="rounded-full border border-[var(--gray-200)] bg-[var(--gray-100)] px-2 py-0.5 text-[11px] font-semibold text-[var(--gray-500)]">
          Convergence
        </span>
        <p className="competitive-body-text truncate">
          <span className="font-semibold text-[var(--gray-900)]">{competitorName}:</span> {text}
        </p>
      </div>
    </article>
  )
}
